export default "__VITE_ASSET__vaDTPagf__"